export default __webpack_public_path__ + "static/media/avatar.5852f40f.svg";